import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/23_card_back_bee/23_card_back_bee"
 * Contains 1 texture(s)
 */
export class CardsBacks23CardBackBeeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/23_card_back_bee/23_card_back_bee';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '23_bee.png'
    ] as const;
}
